// Status color utility functions
export const getStatusColor = (status) => {
  const statusColors = {
    draft: 'text-gray-600 bg-gray-50',
    submitted: 'text-orange-600 bg-orange-50',
    approved: 'text-green-600 bg-green-50',
    rejected: 'text-red-600 bg-red-50',
    revision_requested: 'text-yellow-600 bg-yellow-50',
    active: 'text-green-600 bg-green-50',
    warned: 'text-yellow-600 bg-yellow-50',
    suspended: 'text-red-600 bg-red-50',
    banned: 'text-red-600 bg-red-50',
    flagged: 'text-red-600 bg-red-50',
    resolved: 'text-green-600 bg-green-50',
    dismissed: 'text-gray-600 bg-gray-50',
    under_review: 'text-blue-600 bg-blue-50'
  };
  return statusColors[status] || 'text-gray-600 bg-gray-50';
};

export const getPriorityColor = (priority) => {
  const priorityColors = {
    high: 'text-red-600 bg-red-50',
    medium: 'text-yellow-600 bg-yellow-50',
    low: 'text-green-600 bg-green-50'
  };
  return priorityColors[priority] || 'text-gray-600 bg-gray-50';
};

// Date filtering utility
export const isDateInRange = (dateString, range) => {
  if (range === 'all') return true;
  
  const date = new Date(dateString);
  const now = new Date();
  const daysDiff = Math.floor((now - date) / (1000 * 60 * 60 * 24));
  
  switch (range) {
    case 'today':
      return daysDiff === 0;
    case 'week':
      return daysDiff <= 7;
    case 'month':
      return daysDiff <= 30;
    default:
      return true;
  }
};

// Safe skill rendering utility
export const renderSkill = (skill) => {
  if (typeof skill === 'string') return skill;
  if (skill && typeof skill === 'object' && skill.name) return skill.name;
  return 'Unknown Skill';
};

// Safe array check utility
export const isValidArray = (arr) => {
  return arr && Array.isArray(arr) && arr.length > 0;
};

// Format display text utility
export const formatText = (text, maxLength = 100) => {
  if (!text) return '';
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

// Status mapping for user actions
export const mapUserActionToStatus = (action) => {
  const statusMapping = {
    activate: 'active',
    suspend: 'suspended',
    warn: 'warned',
    ban: 'banned',
    delete: 'deleted' // Admin-initiated deletion
  };
  return statusMapping[action] || action;
};

// Report action status mapping
export const mapReportActionToStatus = (action) => {
  const actionMapping = {
    resolve: 'resolved',
    dismiss: 'dismissed',
    escalate: 'under_review'
  };
  return actionMapping[action];
};
